export default "<div id=\"content\">\n    <div id=\"animation\"></div>\n</div>\n"